export const RETURN_REASONS = [
  { value: '64', label: 'Fit of item too small' },
  { value: '32', label: 'Fit of item too large' },
  { value: '2147483648', label: 'Fit of item not as expected' },
  { value: '274877906944', label: 'Piece(s) missing from item' },
  { value: '512', label: 'Quality of item not as expected' },
  { value: '128', label: 'Color of item not as expected' },
  { value: '1024', label: 'Incorrect color received' },
  { value: '256', label: 'Style of item not as expected' },
  { value: '32768', label: 'Incorrect item received' },
  { value: '288230376151711744', label: 'Incorrect size received' },
  { value: '16384', label: 'Damaged item received' },
  { value: '65536', label: 'Item received after promised delivery date' }
];
